// src/components/UnmatchedSkuBanner.tsx

import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";

interface UnmatchedSkuBannerProps {
  skus: string[];
}

/**
 * Destructive-tone banner shown when a job has materials with SKUs not found
 * in the product registry. Renders a list of offending SKU codes and a link
 * to /product-registry so the user can resolve them.
 */
export function UnmatchedSkuBanner({ skus }: UnmatchedSkuBannerProps) {
  if (skus.length === 0) return null;
  return (
    <div className="bg-destructive/10 border border-destructive/30 rounded-md p-3 space-y-1.5">
      <p className="text-xs font-medium text-destructive flex items-center gap-1.5">
        <AlertTriangle className="h-3.5 w-3.5 shrink-0" />
        {skus.length} SKU{skus.length > 1 ? "s" : ""} not found in Product Registry — ordering is blocked
      </p>
      <ul className="space-y-0.5">
        {skus.map((sku) => (
          <li key={sku} className="text-[10px] font-mono text-destructive/80">
            {sku}
          </li>
        ))}
      </ul>
      <p className="text-[10px] text-destructive/70">
        Add the missing SKUs in the{" "}
        <Link
          to="/product-registry"
          className="underline underline-offset-2 font-medium hover:text-destructive"
        >
          Product Registry
        </Link>{" "}
        before proceeding.
      </p>
    </div>
  );
}
